// Phase 6.C — 작업일정 / 전체 보기 (index).
// 본 trace (2026-05-03 Track A): mock 제거. 회사별 격리 데이터 영역.
// SCHEDULE_SECTIONS = [] 인 한 EmptyState 노출.
// 향후 Phase 7 backend 활성 시 회사별 등록 일정이 카드로 표시.

import { AlertBanner, EmptyState } from '../../components/primitives';
import { useViewport } from '../../lib/useViewport';
import { SCHEDULE_SECTIONS } from './data';
import { SectionCard } from './SectionCard';

export function ScheduleOverviewRoute() {
  const isMobile = useViewport() === 'mobile';
  const isEmpty = SCHEDULE_SECTIONS.length === 0;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <AlertBanner
        tone="info"
        message="작업일정은 사장/직원이 직접 등록하는 회사별 격리 데이터입니다. 메일·SMS·카톡·텔레 발송 + 응답 수신 등 활성화는 Phase 7 메일 인프라 도입 후 진행됩니다."
      />
      {isEmpty ? (
        <EmptyState
          icon="calendar"
          title="등록된 작업일정이 없습니다"
          description="작업일정은 사장/직원이 직접 등록하는 회사별 격리 영역입니다. Phase 7 메일·SMS 인프라 도입 후 등록·발송·응답 수신이 활성됩니다."
        />
      ) : (
        SCHEDULE_SECTIONS.map((s) => (
          <SectionCard key={s.id} section={s} isMobile={isMobile} />
        ))
      )}
    </div>
  );
}
